import {Component} from "react";
import moment from "moment";
import DataAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import {ButtonToolbar, Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import React from "react";

export default class OdKierowcowSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: '',
            dataDo: '',
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
    }

    componentDidMount() {
        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()+1);

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            dataOd: (pierwszy_miesiaca),
            dataDo: (ostatni_miesiaca),
        })
    }

    componentWillReceiveProps(nextprops) {
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onClickSzukaj() {
        if (DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo) >= DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd)) {
            this.props.handleClickSearch({
                dataOd: DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                dataDo: DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
            })
        } else {
            alert('Podano nieprawidłowy zakres dat!')
        }
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data od <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data do <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={12} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj wiadomości'} iconType={'fa fa-search'} btnSize={'md'} btnColor={'primary'}
                                             onClick={() => this.onClickSzukaj()}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/components/odkierowcowComponents/OdKierowcowSearchbox.js